<form [formGroup]="CREDITCARD">
  <section class="CREDITCARD_section">
    <div class="wrapperInner">
      <div class="row innerWrapper">
        <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
          <mat-label>Credit Card Number</mat-label>
          <input matInput placeholder="Enter Credit Card Number" formControlName="credit_card_number" restrictTo NumbersOnly appCardFormate onkeyup="formatCreditCard()" maxlength="20">
          <img matSuffix src="../../../assets/bank_icon/{{credit_card_type.value}}.png" [alt]="credit_card_type.value" class="img-fluid" onerror="this.src='../../../assets/bank_icon/error_payment.png';">
          <mat-error *ngIf="CREDITCARD.controls['credit_card_number'].hasError('required')"><strong>Credit Card</strong> is required.</mat-error>
        </mat-form-field>
        <ng-container  *ngIf="type$ | async as type">
          <mat-form-field class="col-12" hidden>
            <input matInput placeholder="Enter Credit Card Number" formControlName="credit_card_type" [value]="type" [ngModel]="type" readonly>
          </mat-form-field>
        </ng-container>
        <mat-form-field appearance="outline" color="primary" class="col-md-5" floatLabel="always">
          <mat-label>Month</mat-label>
          <mat-select matInput placeholder="Month" formControlName="credit_card_exp_month">
            <mat-option *ngFor="let item of month" [value]="item.value">{{item.name}}</mat-option> <!--{{item.value}}&nbsp;-->
          </mat-select>
          <mat-error *ngIf="CREDITCARD.controls['credit_card_exp_month'].hasError('required')"><strong>Month</strong> is required.</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary" class="col-md-4" floatLabel="always">
          <mat-label>Year</mat-label>
          <mat-select matInput placeholder="Year" formControlName="credit_card_exp_year">
            <mat-option *ngFor="let item of expYears" [value]="item">{{item}}</mat-option>
          </mat-select>
          <mat-error *ngIf="CREDITCARD.controls['credit_card_exp_year'].hasError('required')"><strong>Year</strong> is required.</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary" class="col-md-3" floatLabel="always">
          <mat-label>CVV</mat-label>
          <input *ngIf="credit_card_type.value !== 'amex'" matInput placeholder="CVV" formControlName="credit_card_cvv" restrictTo NumbersOnly appCvvFormat [cardType]="credit_card_type.value" minlength="3" maxlength="3">
          <input *ngIf="credit_card_type.value === 'amex'" matInput placeholder="CVV" formControlName="credit_card_cvv" restrictTo NumbersOnly appCvvFormat [cardType]="credit_card_type.value" minlength="4" maxlength="4">
          <mat-error *ngIf="CREDITCARD.controls['credit_card_cvv'].hasError('required')"><strong>CVV</strong> is required.</mat-error>
          <!-- <mat-hint>CVV</mat-hint> -->
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary" class="col-md-12" floatLabel="always">
          <mat-label>Name on card</mat-label>
          <input matInput placeholder="Enter Name on card" formControlName="credit_card_holder_name"  maxlength="48">
          <mat-error *ngIf="CREDITCARD.controls['credit_card_holder_name'].hasError('required')"><strong>Name on Card</strong> is required.</mat-error>
        </mat-form-field>
      </div>
    </div>
  </section>
</form>